const calculateTaxCredit = (monthly, oneTime, taxKey, taxMax) => {
    const taxCredit = ((12 * monthly) + oneTime) * taxKey
    if (taxCredit > taxMax) {
        return taxMax
    } else {
        return taxCredit
    }
}

export default calculateTaxCredit